import {
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from "@material-ui/core";

import AddIcon from "@material-ui/icons/Add";
import HelpIcon from "@material-ui/icons/Help";
import PlaceIcon from "@material-ui/icons/Place";

import { CompatiblePlaceEditorButtonWithDialog } from "..";
import {
  ServiceCompatiblePlace,
  ServiceCompatiblePlaceType,
} from "../../../graphql/models";

export interface ServiceCompatiblePlacesEditorProps {
  disabled: boolean;
  compatiblePlaces: ServiceCompatiblePlace[];
  onCompatiblePlacesChange: (evt: ServiceCompatiblePlace[]) => void;
}

export function ServiceCompatiblePlacesEditor(
  props: ServiceCompatiblePlacesEditorProps
) {
  const { compatiblePlaces, disabled, onCompatiblePlacesChange } = props;

  const onCompatiblePlaceChange = (
    place: ServiceCompatiblePlace,
    index: number
  ) => {
    const updatedCompatiblePlaces = [...compatiblePlaces];
    updatedCompatiblePlaces.splice(index, 1, place);

    onCompatiblePlacesChange([...updatedCompatiblePlaces]);
  };

  const getPlaceIcon = (place: ServiceCompatiblePlace) => {
    switch (place.type) {
      case ServiceCompatiblePlaceType.AMENITY:
        return <PlaceIcon />;
      default:
        return <HelpIcon />;
    }
  };

  const getPlaceDescription = (place: ServiceCompatiblePlace) => {
    switch (place.type) {
      case ServiceCompatiblePlaceType.AMENITY:
        return place.amenity?.name;
      case ServiceCompatiblePlaceType.APARTMENT:
        return "Appartamento";
      default:
        return "-";
    }
  };

  const addCompatiblePlace = () => {
    onCompatiblePlacesChange([
      ...compatiblePlaces,
      {
        type: ServiceCompatiblePlaceType.APARTMENT,
      },
    ]);
  };

  return (
    <List style={{ width: "100%" }}>
      {compatiblePlaces.map((place, index) => (
        <ListItem key={[place.type, place.amenity?.id].join("-")} dense>
          <ListItemIcon>{getPlaceIcon(place)}</ListItemIcon>
          <ListItemText>{getPlaceDescription(place)}</ListItemText>
          <ListItemSecondaryAction>
            <CompatiblePlaceEditorButtonWithDialog
              disabled={disabled}
              compatiblePlace={place}
              onCompatiblePlaceChange={(el) =>
                onCompatiblePlaceChange(el, index)
              }
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
      {compatiblePlaces.length > 0 && <Divider />}
      <ListItem key="add-new-place">
        <ListItemText style={{ textAlign: "right" }}>
          <Typography variant="subtitle2">Aggiungi</Typography>
        </ListItemText>
        <ListItemSecondaryAction>
          <IconButton
            disabled={disabled}
            onClick={addCompatiblePlace}
            edge="end"
            aria-label="edit"
          >
            <AddIcon />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
    </List>
  );
}
